/**
 * Misc QBT clock: browser GPS only on phone-sized touch devices; shop PCs use server site coords.
 */
export function miscQuickBooksTimePrefersBrowserGeolocation(input?: {
  hasGeolocation?: boolean;
  coarsePointer?: boolean;
  narrowViewport?: boolean;
}): boolean {
  if (input != null) {
    return (
      input.hasGeolocation === true &&
      input.coarsePointer === true &&
      input.narrowViewport === true
    );
  }
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return false;
  }
  if (!("geolocation" in navigator)) {
    return false;
  }
  return (
    window.matchMedia("(pointer: coarse)").matches &&
    window.matchMedia("(max-width: 768px)").matches
  );
}
